<template>
  <CygnusIcon :name="tick ? 'check-circle' : 'x-circle'" variant="solid" :class="tick ? 'toc-tick' : 'toc-cross'" />
</template>

<script setup>
const props = defineProps(
    {
      tick: {
        type: Boolean,
        required: true
      }
    }
)
</script>

<style>
.toc-tick {
  color: green;
}

.toc-cross {
  color: red;
}
</style>
